import React, { FC } from 'react'
interface Template {
  children: React.ReactNode
  title: string
  description?: string
}
const Template:FC<Template> = ({children, title, description=""}) => {
  return (
    <div className='w-100'>
      <div className='card mb-xl-8 p-4'>
        <div className='col'>
          <div className='row'>
            <div className='w-100'>
              <h2 className='fs-1'>{title}</h2>
              <p className='text-black-50'>{description}</p>
            </div>
            <div className=''>{children}</div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Template
